import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if ($("#kube_preferred_bookseller_id")) {
      $("#kube_preferred_bookseller_id").select2({
        templateResult: function(data) {
          if (!data.id) return data.text;
          const pictureUrl = $(data.element).data('picture-url') || 'https://placehold.co/200?text=pas%20d%27image';
          return $(`
            <span style="display: flex; align-items: center;">
              <img src="${pictureUrl}" style="width:32px;height:32px;object-fit:cover;border-radius:50%;margin-right:10px;">
              <span>${data.text}</span>
            </span>
          `);
        },
        templateSelection: function(data) {
          if (!data.id) return data.text;
          const pictureUrl = $(data.element).data('picture-url') || 'https://placehold.co/200?text=pas%20d%27image';
          return $(`
            <span style="display: flex; align-items: center;">
              <img src="${pictureUrl}" style="width:24px;height:24px;object-fit:cover;border-radius:50%;margin-right:8px;">
              <span>${data.text}</span>
            </span>
          `);
        },
        width: '100%'
      });
    }
  }
}
